import { Component, OnInit } from '@angular/core';
import { MasterBlogComponent } from '../../blog/master-blog/master-blog.component';
import { NEWS } from '../../../mokup/news';

@Component({
  selector: 'app-news-popular',
  templateUrl: './news-popular.component.html',
})
export class NewsPopularComponent extends MasterBlogComponent {
  masterList = []
  language;
  ngOnInit(){
 
     super.ngOnInit()
     this.init()
     this.fetchMasterList();

     this.language = this.localSt.retrieve("language");
     if(this.language == null){
      this.language = 'EN';
    }

   }
     async init(){
 
     
   }
   fetchMasterList() {

    // let masterList = await this.ERPAPI.post('crm/newsevent/search', {
    //   // "keyword": ""
    // }).then(res => res.object)

    for (let item of NEWS) {

      if (this.changeLanguage()) {
        this.display.name = item.nameEN;
        this.display.description = item.descriptionEN;
      } else {
        this.display.name = item.nameTH;
        this.display.description = item.descriptionTH;

      }
      this.display.id = item.id;
      this.display.picture = item.picture;
      this.display.createDate = item.createDate
      this.display.typeNews = item.typeNews
      this.masterList.push(JSON.parse(JSON.stringify(this.display)));

    }

    // return masterList;

  }
}



// WEBPACK FOOTER //
// ./src/app/components/blog/news-popular/news-popular.component.ts